import type { ObservableRequest } from '@swf/core/hooks/useRequest';

interface TokenResponse {
  token: string;
}

export const fetchToken = (request: ObservableRequest, retryCount = 0) =>
  request<TokenResponse>({
    service: `/api/v1-preview/account/sumsub/token`,
    http: true,
    retry: { count: retryCount }
  });

export function sendStartVerificationRequest(
  {
    request
  }: {
    request: ObservableRequest;
  },
  vendor?: string
) {
  request({
    service: '/api/v1-preview/account/docverify',
    method: 'POST',
    http: true,
    retry: { count: 2 },
    body: {
      vendor
    }
  });
}
